var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"shrink"},[_c('v-icon',[_vm._v("villa")])],1),_c('v-col',[_c('vs-heading',{attrs:{"type":"subhead"}},[_vm._v(_vm._s(_vm.name))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }